import ChecklistSplash from './ChecklistSplash'

export default ChecklistSplash
